module.exports = __webpack_public_path__ + "img/iconPhone.8ebc6d24.svg";